import React from "react";

import { TimelineOption } from "consts";

import { Typography } from "components";

import { CMComparisonTable } from "pages/app/scenario-analysis/components/CMComparisonTable";
import { ForecastChart } from "pages/app/scenario-analysis/components/ForecastChart";
import { ScenarioData } from "pages/app/scenario-analysis/types/scenario";
import { SoilSightOutcomesByScenario, ViewMode, buildForecastDataFromSoilSight } from "pages/app/scenario-analysis/utils/forecast";

const PdfSubHeader = ({ label }: { label: string }) => (
  <Typography variant="paragraph-s" bold className="pdf-subheader">
    {label}
  </Typography>
);

type PdfChartAndTableProps = {
  viewMode: ViewMode;
  testIdPrefix: string;
  tableLabel: string;
  scenarios: ScenarioData[];
  projectionYears: TimelineOption;
  forecastData: ReturnType<typeof buildForecastDataFromSoilSight>;
  mainCropLabelLookup: Record<string, string>;
  soilSightOutcomes: SoilSightOutcomesByScenario | null;
  marketPricePct: number;
  costDevelopmentPct: number;
};

/** The results chart and its per-year table, as the outcomes page shows them for one view. */
export const PdfChartAndTable = ({
  viewMode,
  testIdPrefix,
  tableLabel,
  scenarios,
  projectionYears,
  forecastData,
  mainCropLabelLookup,
  soilSightOutcomes,
  marketPricePct,
  costDevelopmentPct,
}: PdfChartAndTableProps) => (
  <>
    <div className="pdf-chart-wrap">
      <ForecastChart
        variant="report"
        scenarios={scenarios}
        projectionYears={projectionYears}
        forecastData={forecastData}
        viewMode={viewMode}
        mainCropLabelLookup={mainCropLabelLookup}
        dataTestId={`pdf-forecast-chart-${testIdPrefix}`}
      />
    </div>
    <div className="pdf-table-block">
      <PdfSubHeader label={tableLabel} />
      <div className="pdf-table-wrap">
        <CMComparisonTable
          scenarios={scenarios}
          projectionYears={projectionYears}
          forecastData={forecastData}
          viewMode={viewMode}
          mainCropLabelLookup={mainCropLabelLookup}
          soilSightOutcomes={soilSightOutcomes}
          marketPricePct={marketPricePct}
          costDevelopmentPct={costDevelopmentPct}
          dataTestId={`pdf-table-${testIdPrefix}`}
        />
      </div>
    </div>
  </>
);
